import { render, staticRenderFns } from "./PersonnelStatsCards.vue?vue&type=template&id=065967d5&scoped=true"
import script from "./PersonnelStatsCards.vue?vue&type=script&lang=js"
export * from "./PersonnelStatsCards.vue?vue&type=script&lang=js"
import style0 from "./PersonnelStatsCards.vue?vue&type=style&index=0&id=065967d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065967d5",
  null
  
)

export default component.exports